import React from "react";
import { connect } from "react-redux";
import * as _ from 'lodash';
import { Alert, Button } from 'react-bootstrap'
import { IAppState } from "../../state/interfaces";
import { IOfferErrors, ICoverageConfig, IVehicleBase } from "../../classes/Domain";

export interface IProps {
    offerErrors: IOfferErrors,
    vehicle: IVehicleBase,
    selectedCoverageConfig: ICoverageConfig,
    reRate?: () => void;
}

class VehiclePhysicalDamage extends React.Component<IProps> {
    componentDidMount() {
        console.log("VehiclePhysicalDamage");
    }

    rejectVehicleCoverage(coverageCode: string) {
        const vehicleCoverages = _.find(this.props.selectedCoverageConfig.vehicleCoverages, (vcov) => vcov.vehicleId === this.props.vehicle.id);
        if (!vehicleCoverages) return;
        const cov = _.find(vehicleCoverages.coverages, (cov) => cov.code === coverageCode);
        console.log(cov);

        if (cov) {
            cov.isSelected = false;
        }
    }

    removeCoverages() {
        this.rejectVehicleCoverage("COMP");
        this.rejectVehicleCoverage("COLL");

        if (this.props.reRate) {
            this.props.reRate();
        }
    }

    render() {
        return (
            <div>
                <Alert variant={"warning"} className="m-t-20">
                    <p className="message-body" dangerouslySetInnerHTML={{ __html: this.props.offerErrors.text }}></p>
                    <p className="message-body">Remove COMP/COLL?</p>
                    <p className="text-center">
                        <Button
                            size="sm"
                            onClick={() => this.removeCoverages()}>
                            OK
                        </Button>
                    </p>
                </Alert>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IProps) => {
    console.log(ownProps);
    const vehicle = _.find(state.vehicles, (v) => v.vin === ownProps.offerErrors.domainKey);
    console.log(vehicle);

    return {
        ...ownProps,
        vehicle: vehicle,
        selectedCoverageConfig : state.coverageConfig
    };
};

export default connect(mapProps, null)(VehiclePhysicalDamage);
